import {createAsyncThunk} from '@reduxjs/toolkit'

import {ROUTER_ORDER_SALE_SETTLEMENT} from '@web/core/routes'
import {changeBrowserLocation} from '@web/helpers/browser'
import {push} from '@web/slices/router'

import {LocationChangeHistoryWithRouteParam, ThunkApi} from '../interfaces'

type NavigateToSaleSettlementDetailParam = LocationChangeHistoryWithRouteParam & {
    orderNo: string
}

/** 정산내역 */
const navigateToSaleSettlementDetail = createAsyncThunk<void, NavigateToSaleSettlementDetailParam, ThunkApi<unknown>>(
    'navigateTo/sale/settlement/detail',
    ({historyType = 'PUSH', orderNo, routeBased = false}, {dispatch}) => {
        if (routeBased) {
            dispatch(push(ROUTER_ORDER_SALE_SETTLEMENT.DETAIL.getPath(orderNo), {resetScroll: routeBased}))
        } else {
            changeBrowserLocation({
                type: historyType,
                url: ROUTER_ORDER_SALE_SETTLEMENT.DETAIL.getHref(orderNo),
            })
        }
    },
)

export default navigateToSaleSettlementDetail
